const BUSCANDO = (state, payload) => {
  state.buscando = payload
}

const INSERIR_LISTA_FORMULARIOS = (state, payload) => {
  state.items = payload
}

const INSERIR_FORMULARIO = (state,  payload) => {  
  state.items.data.push(payload)
}

const ATUALIZAR_FORMULARIO = (state, payload) => {
  state.items.data = state.items.data.map(item => {
    if(item.id === payload.id) {
      return payload;
    }
    return item;
  })
}

const INSERIR_FORMULARIOS_SELECIONADOS = (state,  payload) => {
  state.items = payload
}

const ATUALIZAR_FORMULARIOS_SELECIONADOS = (state,  payload) => {
  state.items[payload.instanciaIdent] = payload.formularios;
}

const INSERIR_FORMULARIO_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

const INSERIR_FORM_VALUES = (state,  payload) => {
  state.formValues = payload
}

const INSERIR_ITEM_OPTIONS = (state,  payload) => {
  
  console.log('Payload de options: ', payload)
  
  state.items[payload.instanciaIdent][0].dados.corpo.forEach(item => {
    if(item.name === payload.name) {
      item.options = payload.options
    }
  })
  console.log('Estado do component: ', state)
  console.log(state.items[payload.instanciaIdent][0].dados.corpo);
}

export {
  BUSCANDO,
  INSERIR_LISTA_FORMULARIOS,
  INSERIR_FORMULARIO,
  INSERIR_FORMULARIO_SELECIONADO,
  INSERIR_FORM_VALUES,
  INSERIR_ITEM_OPTIONS,
  ATUALIZAR_FORMULARIO,
  INSERIR_FORMULARIOS_SELECIONADOS,
  ATUALIZAR_FORMULARIOS_SELECIONADOS
}